export const OPEN_HISTORY_UPLOAD_DIALOG = 'OPEN_HISTORY_UPLOAD_DIALOG';
export const RESET_HISTORY_UPLOAD_DIALOG = 'RESET_HISTORY_UPLOAD_DIALOG';
export const START_QUERY_HISTORY_UPLOAD = 'START_QUERY_HISTORY_UPLOAD';
export const QUERY_HISTORY_UPLOAD_SUCESS = 'QUERY_HISTORY_UPLOAD_SUCESS';
export const QUERY_HISTORY_UPLOAD_FAILURE = 'QUERY_HISTORY_UPLOAD_FAILURE';
export const INIT_QUERY_HISTORY_UPLOAD_STATUS = 'INIT_QUERY_HISTORY_UPLOAD_STATUS';
